import { useParams } from 'react-router-dom'
import useTitle from '../../hooks/useTitle'
import NewHepExerciseForm from './NewHepExerciseForm'
import { useGetExercisesQuery } from "../exercises/exercisesApiSlice"
import { useGetBodypartsQuery } from "../exercises/bodypartsApiSlice"
import { useGetExercisetypesQuery } from "../exercises/exercisetypesApiSlice"




const NewHepExercise = () => {

    useTitle('DPE: New HEP Exercise')

    // get hep_id
    const { id } = useParams()

    const { exercises } = useGetExercisesQuery("exercisesList", {
        selectFromResult: ({ data }) => ({
            exercises: data?.ids.map(id => data?.entities[id])
        }),
    })

    const { bodyparts } = useGetBodypartsQuery("bodypartsList", {
        selectFromResult: ({ data }) => ({
            bodyparts: data?.ids.map(id => data?.entities[id])
        }),
    })

    const { exercisetypes } = useGetExercisetypesQuery("exercisetypesList", {
        selectFromResult: ({ data }) => ({
            exercisetypes: data?.ids.map(id => data?.entities[id])
        }),
    })
    
    
    

    const content = <NewHepExerciseForm id={id} exercises={exercises} bodyparts={bodyparts} exercisetypes={exercisetypes} />
  
    return content
}

export default NewHepExercise